import { useEffect, useState } from 'react'
import { BrowserRouter, Routes, Route} from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async';
import { LanguageProvider } from './i18n/LanguageContext';

import Header from './components/Header'
import Garage from './components/Garage'
import About from './components/About'
import Footer from './components/Footer'
import NotFound from './components/NotFound'
import ScrolloTop from './components/ScrollToTop'
import Privacy from './components/Privacy';
import Home from './pages/Home';
import { MainWrapper } from './Utilities';


const CACHE_VERSION = '3'

const App = () => {
  const [data, setData] = useState([])
  const [loader, setLoader] = useState(true)

  useEffect(() => {
    // Clear cache if it was built with an older version of the app
    try {
      if (sessionStorage.getItem('garageDataVersion') !== CACHE_VERSION) {
        sessionStorage.removeItem('garageData')
        sessionStorage.removeItem('garageDataFetchTime')
        sessionStorage.setItem('garageDataVersion', CACHE_VERSION)
      }
    } catch (e) {
      console.warn('sessionStorage not available:', e)
    }

    function timeout(delay) {
      return new Promise(res => setTimeout(res, delay));
    }

    const fetchData = async (showLoader) => {
      if (showLoader) await timeout(4000);
      const res = await fetch(process.env.REACT_APP_API_URL)
      const json = await res.json()
      setLoader(false)
      const fetchedAt = json.timeStamp || new Date().toISOString()
      return json.features
        .filter(f => f.properties.naam !== 'Floridastraat' && f.properties.naam !== 'Station')
        .map(f => ({ ...f, properties: { ...f.properties, lastFetched: fetchedAt } }))
    }

    const getData = async (showLoader = true) => {
      try {
        console.log('[Parking] Fetching data...', new Date().toLocaleTimeString())
        const dataFromServer = await fetchData(showLoader)
        try {
          sessionStorage.setItem('garageData', JSON.stringify(dataFromServer))
          sessionStorage.setItem('garageDataFetchTime', new Date().toISOString())
        } catch (e) {
          console.warn('sessionStorage not available:', e)
        }
        setData(dataFromServer)
        console.log('[Parking] Data updated', new Date().toLocaleTimeString())
      } catch (err) {
        console.error('Kon garagedata niet ophalen:', err)
        setLoader(false)
      }
    }

    let fetchTime, cachedData
    try {
      fetchTime = sessionStorage.getItem('garageDataFetchTime')
      cachedData = sessionStorage.getItem('garageData')
    } catch (e) {
      console.warn('sessionStorage not available:', e)
    }
    if (cachedData === null || !fetchTime) {
      getData(true)
    } else {
      const minutesSinceFetch = (new Date() - new Date(fetchTime)) / 60000
      if (minutesSinceFetch > 5) {
        try {
          sessionStorage.removeItem('garageData')
          sessionStorage.removeItem('garageDataFetchTime')
        } catch (e) {
          console.warn('sessionStorage not available:', e)
        }
        getData(true)
      } else {
        try {
          setData(JSON.parse(cachedData))
        } catch (e) {
          console.warn('Failed to parse cached data:', e)
          getData(true)
        }
        setLoader(false)
      }
    }

    // Auto-refresh every 5 minutes (silently, no loader)
    const interval = setInterval(() => getData(false), 5 * 60 * 1000)
    return () => clearInterval(interval)
  }, [])

  return (
    <LanguageProvider>
    <HelmetProvider>
      <BrowserRouter>
        <ScrolloTop />
        <Header />
        <MainWrapper>
          <Routes>
              <Route path='/' element={<Home garageData={data} loadFigure={loader} />} />
              <Route path='/garage/:id' element={<Garage garageData={data} loadFigure={loader}/>} />
              <Route path='/over-ons' element={<About />} />
              <Route path='/privacybeleid' element={<Privacy />} />
              <Route path='/pagina-niet-gevonden' element={<NotFound />} />
              {/* <Route path='*' element={<NotFound />} /> */}
          </Routes>
        </MainWrapper>
        {/* <WarningBanner /> */}
        <Footer />
      </BrowserRouter>
    </HelmetProvider>
    </LanguageProvider>
  );
}

export default App;
